var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPromotions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Promotions",
    fill: "none",
    className: "default"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21 10.998h-8v-3h8v3zm-8 10h6v-9h-6v9zM12.5 6.18c-.055-.334 1.739-1.369 4.338-1.902 1.079-.222 1.726-.286 2.113-.286.379 0 .508.06.548.098.043.226-.563 1.072-1.487 1.774-.549.417-1.467 1.115-2.859 1.135-1.359.04-2.606-.538-2.653-.818zm-1 0c-.047.28-1.335.86-2.653.819-1.392-.02-2.31-.718-2.859-1.135-.924-.702-1.53-1.548-1.499-1.753.047-.048.184-.117.581-.117.392 0 1.034.067 2.092.283 2.599.534 4.393 1.569 4.338 1.904zM11 11H3V8h8v3zM5 21h6v-9H5v9zM21.5 7h-3.35c.179-.123.338-.241.467-.34.18-.136 1.757-1.364 1.875-2.43a.985.985 0 00-.219-.764c-.607-.718-2.195-.463-3.636-.167-.174.035-3.387.715-4.637 1.917-1.25-1.202-4.463-1.881-4.637-1.917-1.439-.296-3.028-.553-3.636.167a.981.981 0 00-.219.764c.118 1.066 1.695 2.293 1.875 2.43.129.099.288.216.467.34H2.5a.5.5 0 00-.5.5v4a.5.5 0 00.5.5H4v9.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5V12h1.5a.5.5 0 00.5-.5v-4a.5.5 0 00-.5-.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Promotions-hover",
    fill: "none",
    fillRule: "evenodd",
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11 11.998v10H4.5c-.28 0-.5-.22-.5-.5v-9.5h7zm9 0v9.5c0 .28-.22.5-.5.5H13v-10h7z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2.998)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13.15 4h-.13c-1.31 0-2.47-.55-2.52-.82v-.01c0-.35 1.78-1.37 4.34-1.89 1.08-.22 1.72-.29 2.11-.29.38 0 .51.06.55.1.04.23-.56 1.07-1.49 1.77-.55.42-1.47 1.12-2.86 1.14zM9.5 3.18c-.05.27-1.25.82-2.52.82h-.13c-1.39-.02-2.31-.72-2.86-1.14-.93-.7-1.53-1.54-1.5-1.75.05-.05.18-.11.58-.11.39 0 1.03.06 2.09.28C7.72 1.8 9.5 2.82 9.5 3.17v.01zm10 .82h-3.34c.18-.13.33-.24.46-.34.18-.14 1.75-1.36 1.87-2.43a.924.924 0 00-.22-.76c-.6-.72-2.19-.47-3.63-.17-.18.04-3.38.71-4.64 1.91C8.74 1.01 5.54.34 5.36.3 3.92 0 2.33-.25 1.73.47a.924.924 0 00-.22.76C1.63 2.3 3.2 3.52 3.38 3.66c.13.1.28.21.46.34H.5c-.28 0-.5.22-.5.5V8h20V4.5c0-.28-.22-.5-.5-.5z"
  })))));
}

SvgPromotions.displayName = 'Promotions';
export default SvgPromotions;